// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton__2X9dS","shimmer":"shimmer__2GixP"};